export default __webpack_public_path__ + "6f8c7ab0d2ecb59667cd3bd263a895d2.png";